import { forwardRef, type Ref, type SVGProps } from "react";
const IconHouseCheckmarkOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M21.878 13.086a1 1 0 0 1 1.393 1.434l-9.776 9.5-4.86-4.498a1 1 0 0 1 1.36-1.468l3.466 3.21z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.8 1.9a2 2 0 0 1 2.4 0l10.09 9.5a2 2 0 0 1 .71 1.53V28a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V12.93a2 2 0 0 1 .71-1.53zM6 12.93V28h20V12.93L16 3.52z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconHouseCheckmarkOutlineSVG);
ForwardRef.displayName = "IconHouseCheckmarkOutline";
export { ForwardRef as IconHouseCheckmarkOutline };
